import React, { Fragment, useEffect, useState } from "react";
import withRouter from "components/Common/withRouter";
import { useDispatch, useSelector } from "react-redux";
import countryCodes from '../Organization/CountryCode';
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { Container, CardBody, CardTitle, Col, Row, Form, Label, Input, Button, UncontrolledTooltip } from "reactstrap";
import Card from "components/PurpleTheme/Card";
import PropTypes from "prop-types";
import maintanence from "../../assets/images/coming-soon.svg"
import { Link } from "react-router-dom";
import profileImg from "../../assets/images/profile.png";

import * as Yup from "yup";
import { useFormik } from "formik";
import { showNotification } from "components/Common/notification";
import { getUserProfile } from "helpers/fakebackend_helper";
import {
  getOrganization as onGetOrganization,
  profileSuccess,
  toggleSsoOnlyLogin as onToggleSsoOnlyLogin,
  updatePassword,
  updateTwoFactorAuth
} from "store/actions";
import OnUpdateContactModal from './OnUpdateContactModal';
import OnUpdateNameModal from './OnUpdateNameModal';
import OnUpdateProfilePicModal from "./OnUpdateProfilePicModal";
import InitialsAvatar from "./InitialsAvatar";
import Switch from "react-switch";
import DocsTooltip from "components/Common/DocsTooltip";

const Profile = props => {

  const dispatch = useDispatch();

  const [data, setData] = useState(null);

  const [passwordShown, setPasswordShown] = useState([false, false, false]);

  const [phoneNumber, setPhoneNumber] = useState(null);

  const [code, setCode] = useState(null);

  const [twoFactorEnabled, setTwoFactorEnabled] = useState(false);

  const [modal, setModal] = useState(false);
  const [nameModal, setNameModal] = useState(false);
  const [profilePicModal, setProfilePicModal] = useState(false);
  const [tooltip, setTooltip] = useState(false);
  const [org2faEnabled, setOrg2faEnabled] = useState(false);

  const { success } = useSelector(state => ({
    success: state.Profile.success
  }));

  const { organizationDetail } = useSelector(state => ({
    organizationDetail: state.Organization.organization || [],
  }));

  const togglePassword = (idx) => {
    let newarray = [...passwordShown];
    newarray[idx] = !passwordShown[idx];
    setPasswordShown(newarray);
  };

  const getUserData = async () => {
    const data = await getUserProfile();
    setData(data);
  }
  useEffect(() => {
    getUserData();
    if (success.length > 0)
      dispatch(profileSuccess(''));
  }, [success])

  useEffect(() => {
    if (data?.phone_number) {
      let len = data?.phone_number.length;
      let number = data?.phone_number.substr(len - 10, len);
      let number_code = data?.phone_number.substr(0, len - 10);
      let code = countryCodes.find(code => code.value === number_code);
      if (code)
        code = code.value
      else
        code = '';
      setCode(code);
      setPhoneNumber(number);
    }
  }, [data])

  useEffect(() => {
    dispatch(onGetOrganization());
  }, [onGetOrganization]);

  useEffect(() => {
    if(organizationDetail?.two_factor_default){
      setOrg2faEnabled(organizationDetail?.two_factor_default)
    }else {
      setOrg2faEnabled(false)
    }
  }, [organizationDetail]);

  const toggle = () => {
    if (modal) {
      setModal(false);
    } else {
      setModal(true);
    }
  }

  const nameToggle = () => {
    if (nameModal) {
      setNameModal(false);
    } else {
      setNameModal(true);
    }
  }

  const profilePicToggle = () => {
    if (profilePicModal) {
      setProfilePicModal(false);
    } else {
        setProfilePicModal(true);
    }
  }

  const onUpdateNumber = () => {
    toggle();
  }

  const onUpdateName = () => {
    nameToggle();
  }

  const onUpdateProfilePic = () => {
    profilePicToggle()
  }

  useEffect(() => {
  if(data?.is_two_factor_enabled){
    setTwoFactorEnabled(true)
  }else {
    setTwoFactorEnabled(false)
  }
}, [data])

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {},
    validate: (values) => {
      const errors = {};
      var password_format = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,30}$/;
      if (!values.new_password) {
        errors.new_password = "Please Enter Your new Password";
      }
      else if (!password_format.test(values.new_password)) {
        errors.new_password = 'Password should be at least 8 characters and should contain lowercase letters, uppercase letters, numeric digits and special characters';
      } else if (values.new_password !== values.confirm_new_password) {
        errors.confirm_new_password = "Password do not match";
      }
      return errors;
    },
    validationSchema: Yup.object({
      old_password: Yup.string().required("Please Enter Your Current Password"),
      new_password: Yup.string().required("Please Enter Your new Password"),
      confirm_new_password: Yup.string().required("Please Confirm Your New Password"),
    }),
    onSubmit: (values, { resetForm }) => {
      if (values.old_password === values.new_password) {
        showNotification("warning", "New password should not be same as current password");
      } else {
        dispatch(updatePassword(values));
        resetForm({ values: '' });
      }
    }
  });

  const toggleTwoFactorAuthentication = () => {
    setTwoFactorEnabled(!twoFactorEnabled)
    let payload = {"user_id":data?.id}
    dispatch(updateTwoFactorAuth(payload))
  }

  const OffSymbol = () => {
    return (
        <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
              fontSize: 12,
              color: "#fff",
              paddingRight: 1
            }}
        >
        </div>
    );
  };

  const OnSymbol = () => {
    return (
        <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
              fontSize: 12,
              color: "#fff",
              paddingRight: 1
            }}
        >
        </div>
    );
  };

  return (
    <React.Fragment>
      <OnUpdateNameModal isOpen={nameModal} toggle={nameToggle} userPhoneNumber={data?.phone_number} />
      <OnUpdateContactModal isOpen={modal} toggle={toggle} />
      <OnUpdateProfilePicModal isOpen={profilePicModal} toggle={profilePicToggle} userEmail={data?.email} page="Profile" />
      <div className="page-content">
        <Container>
          <Card>
            <Row >
              <Col xl="6">

                  <CardBody>
                    <CardTitle className="mb-4 d-flex align-items-center gap-1">
                      Profile
                      <span role="button" id='profileTooltip'>
                        <i className='bx bx-help-circle font-size-1 text-white' />
                      </span>
                      <DocsTooltip 
                        placement={'right'}
                        isOpen={tooltip}
                        toggle={() => setTooltip(!tooltip)}
                        targetId={'profileTooltip'}
                        content={'Need help'}
                        linkText={'Managing your Profile?'}
                        link={'https://docs.temperstack.com/temperstack/overview/integrating-temperstack-as-the-incident-management-tool#manage-your-profile'}
                      />
                    </CardTitle>
                    <div className="table-responsive">
                      <div className="d-flex justify-content-center">
                        <div className="d-flex justify-content-center position-relative"
                             style={{
                               width: "100px",
                               height: "100px",
                               marginBottom: "10px"
                             }}>
                          {data?.profile_picture_url ? (
                              <img
                                  src={data.profile_picture_url}
                                  alt="Profile"
                                  style={{
                                    borderRadius: "50%",
                                    width: "100%",
                                    height: "100%",
                                    marginBottom: "20px"
                                  }}
                              />
                          ) : ( (data?.name) ?
                              <InitialsAvatar name={data?.name} dimensions="100%" id='TooltipTop'/>
                              :
                              <div style={{height: "100px", width:"100px"}}>
                                <img src={profileImg} className="w-100 h-100" />
                              </div>
                          )}
                          {(data?.name && data?.profile_picture_url) && 
                          <div className="position-absolute bottom-0 end-0">
                          <Link
                              className="text-success p-1"
                              onClick={() => onUpdateProfilePic()}
                          >
                            <div className="bg-white px-1 rounded-circle">
                            <i className="mdi mdi-pencil font-size-16" id="editProfilePictooltip"/>

                            </div>
                            <UncontrolledTooltip placement="top" target="editProfilePictooltip">
                              Update Profile Picture
                            </UncontrolledTooltip>
                          </Link>
                        </div>
                          }
                        </div>
                      </div>

                      <table className="table-purple-org" style={{backgroundColor:"#423b3e34"}}>
                        <tbody>
                        <tr>
                          <td scope="col">Name:</td>
                          <td scope="col">{data?.name && (
                              <div className="gap-3 flex">
                                <span>{data?.name}</span>
                                <Link
                                    className="text-success p-1"
                                    onClick={() => onUpdateName(data?.name)}
                                >
                                  <i className="mdi mdi-pencil font-size-18" id="editNametooltip"/>
                                  <UncontrolledTooltip placement="top" target="editNametooltip">
                                    Update Name
                                  </UncontrolledTooltip>
                                </Link>
                              </div>
                          )}</td>
                        </tr>
                        <tr>
                          <td scope="col">Email:</td>
                          <td scope="col">{data?.email}</td>
                        </tr>
                        <tr>
                          <td scope="col">Role:</td>
                          <td scope="col">{data?.role}</td>
                        </tr>
                        <tr>
                          <td scope="col">Phone Number:</td>
                          <td scope="col">
                            {
                              data?.phone_number ? (
                                  <div className="gap-3 flex">
                                    <span>{`${code}-${phoneNumber}`}</span>
                                    <Link
                                        className="text-success p-1"
                                        onClick={() => onUpdateNumber(data?.phone_number)}
                                    >
                                      <i className="mdi mdi-pencil font-size-18" id="edittooltip"/>
                                      <UncontrolledTooltip placement="top" target="edittooltip">
                                        Update Contact Number
                                      </UncontrolledTooltip>
                                    </Link>
                                  </div>
                              ) : (
                                  <Link
                                      className="text-success"
                                      onClick={
                                        onUpdateNumber
                                      }
                                  >
                                    <i className="mdi mdi-pencil font-size-18" id="edittooltip"/>
                                    <UncontrolledTooltip placement="top" target="edittooltip">
                                      Add a contact number
                                    </UncontrolledTooltip>
                                  </Link>
                              )
                            }
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </CardBody>
              </Col>
              <Col xl="6">
                  <CardBody>
                    <CardTitle className="mb-4 card-title">Change Password</CardTitle>
                    <Form
                        className="form-horizontal"
                        onSubmit={(e) => {
                          e.preventDefault();
                          validation.handleSubmit();
                        }}
                    >
                      <Row>
                        <Col sm="11">
                          <div className="mb-3">
                            <Label htmlFor="old_password">Current Password</Label>
                            <div className="d-flex bg-transparent rounded outerInput" style={{border:"1px solid whitesmoke"}}>
                            <Input
                                id="old_password"
                                name="old_password"
                                type={passwordShown[0] ? "text" : "password"}
                                className="input"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.old_password || ""}
                                invalid={
                                  validation.touched.old_password && validation.errors.old_password ? true : false
                                }
                              />
                              {
                                passwordShown[0] ?
                                  <i className="password-label fa fa-eye me-2 input-label"
                                    onClick={() => togglePassword(0)}></i>
                                  :
                                  <i className="password-label fa fa-eye-slash me-2 input-label" onClick={() => togglePassword(0)}></i>
                              }
                            </div>
                            {
                              validation.touched.old_password && validation.errors.old_password ?
                                (<div className="invalid-error">{validation.errors.old_password}</div>)
                                : null
                            }
                          </div>
                        </Col>
                        <Col sm="11">
                          <div className="mb-3">
                            <Label htmlFor="new_password">New Password</Label>
                            <div className="d-flex bg-transparent rounded outerInput" style={{border:"1px solid whitesmoke"}}>
                              <Input
                                id="new_password"
                                name="new_password"
                                type={passwordShown[1] ? "text" : "password"}
                                className="input"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.new_password || ""}
                                invalid={
                                  validation.touched.new_password && validation.errors.new_password ? true : false
                                }
                              />
                              {
                                passwordShown[1] ?
                                  <i className="password-label fa fa-eye me-2 input-label"
                                    onClick={() => togglePassword(1)}></i>
                                  :
                                  <i className="password-label fa fa-eye-slash me-2 input-label" onClick={() => togglePassword(1)}></i>
                              }
                            </div>
                            {
                              validation.touched.new_password && validation.errors.new_password ?
                                (<div className="invalid-error">{validation.errors.new_password}</div>)
                                : null
                            }
                          </div>
                        </Col>
                        <Col sm="11">
                          <div className="mb-3">
                            <Label htmlFor="confirm_new_password">Confirm Password</Label>
                            <div className="d-flex bg-transparent rounded outerInput" style={{border:"1px solid #BCBBBB"}}>
                              <Input
                                id="confirm_new_password"
                                name="confirm_new_password"
                                type={passwordShown[2] ? "text" : "password"}
                                className="input"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.confirm_new_password || ""}
                                invalid={
                                  validation.touched.confirm_new_password && validation.errors.confirm_new_password ? true : false
                                }
                              />
                              {
                                passwordShown[2] ?
                                  <i className="password-label fa fa-eye me-2 input-label"
                                    onClick={() => togglePassword(2)}></i>
                                  :
                                  <i className="password-label fa fa-eye-slash me-2 input-label" onClick={() => togglePassword(2)}></i>
                              }
                            </div>
                            {
                              validation.touched.confirm_new_password && validation.errors.confirm_new_password ?
                                (<div className="invalid-error">{validation.errors.confirm_new_password}</div>)
                                : null
                            }
                          </div>
                        </Col>
                        <Col sm="11">
                        <div className="d-flex align-items-center" style={{justifyContent:'space-between'}}>
                          <div className="d-flex gap-2 align-items-center">
                            <div>Enable Two Factor Authentication</div>
                            <Switch
                                disabled={org2faEnabled}
                                uncheckedIcon={<OffSymbol/>}
                                checkedIcon={<OnSymbol/>}
                                className="me-1 mb-sm-8"
                                height={20}
                                width={44}
                                onColor="#34c38f"
                                offColor="#f46a6a"
                                boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                activeBoxShadow="0px 0px 1px 5px"
                                onChange={() => toggleTwoFactorAuthentication()}
                                checked={twoFactorEnabled}
                            />
                            
                          </div>
                            <Button type="submit" color="primary" className="btn">
                              Update Details
                            </Button>
                            </div>
                        </Col>
                      </Row>
                      
                    </Form>
                  </CardBody>
              </Col>
            </Row>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
};

Profile.propTypes = {
  t: PropTypes.any,
};

export default withRouter(Profile);
